import { Button, Image } from '@heroui/react';
import { useEffect } from 'react';
import LoadingSpinner from '../../../../shared/components/loading-spinner/LoadingSpinner';
import { useAppDispatch, useAppSelector } from '../../../../core/rootHooks';
import { AppDispatch, RootState } from '../../../../core/store';
import { getSubscribedMsiVesselImageDataRequest } from '../../../../user-management/appSlice';
import { selectVesselImageData } from '../../../../user-management/appSelectors';
import VesselImageCopyright from '../../../../shared/components/image-copyrights/VesselImageCopyright';
import { TVesselInfo } from '../../mapTypes';
import { selectSubscribedMsiVesselByImoNumber } from '../../../../shared/sharedSelectors';
import { LuShip } from 'react-icons/lu';
import { VesselInfo } from './VesselInfo';

export interface ISignalClickPopupContentProps {
	info: TVesselInfo;
	title?: string;
	handleVesselDetailButtonOnClick: () => void;
	isLoading: boolean;
	showVesselDetailButton: boolean;
	errorMessage?: string;
}

const SignalClickPopupContent = ({
	info,
	handleVesselDetailButtonOnClick,
	isLoading,
	showVesselDetailButton,
	errorMessage,
}: ISignalClickPopupContentProps) => {
	const dispatch = useAppDispatch<AppDispatch>();
	const imoNumber = info?.features[0]?.properties?.imoNumber || 0;

	const vesselImageData = useAppSelector((state: RootState) => selectVesselImageData(state, imoNumber));

	const vesselData = useAppSelector((state: RootState) => selectSubscribedMsiVesselByImoNumber(state, imoNumber));

	useEffect(() => {
		dispatch(
			getSubscribedMsiVesselImageDataRequest({
				sectorCode: vesselData.sectorCode || '',
				imoNumber,
			}),
		);
	}, [dispatch, imoNumber, vesselData.sectorCode]);

	return (
		<div className="rounded w-72 h-full">
			<div className=" flex flex-col w-full relative gap-1">
				<div className="flex flex-row flex-1 items-center justify-center">
					{vesselImageData === undefined ? (
						<LoadingSpinner size="lg" spinnerClassName="w-52 h-32 self-center" />
					) : vesselImageData.name === 'no_vessel_image' ? (
						<div className="flex items-center justify-center">
							<LuShip className="w-full h-48" color="#3F4B4B" strokeWidth={0.5} />
						</div>
					) : (
						<Image
							src={vesselImageData.imageData}
							alt="Ship Image"
							style={{ objectFit: 'cover', width: 288, height: 192 }}
							className="rounded"
						/>
					)}
				</div>
				<div className="flex flex-col text-xs space-y-1 text-center">
					<VesselImageCopyright vesselName={vesselImageData?.name} sourceUrl={vesselImageData?.sourceUrl} />
				</div>
			</div>

			<VesselInfo vesselData={vesselData} />

			<div className="flex flex-row flex-1 items-center justify-center">
				{isLoading ? (
					<LoadingSpinner size="md" spinnerClassName="p-2" />
				) : (
					showVesselDetailButton && (
						<Button
							color="primary"
							className="w-full mt-2 rounded"
							size="sm"
							onPress={handleVesselDetailButtonOnClick}
							isDisabled={isLoading}
						>
							View Details
						</Button>
					)
				)}
				{errorMessage && <span>{errorMessage}</span>}
			</div>
		</div>
	);
};

export default SignalClickPopupContent;
